import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function CostComparison() {
  const bullets = ['Sin más noches buscando cómo explicar la aerodinámica o el ciclo de un motor turbina en lenguaje de aula', 'Sin más clases armadas de apuro con material que no funciona con alumnos técnicos', 'Sin más alumnos desconectados que no entienden para qué sirve aprender aeronáutica', 'Sin más fines de semana construyendo evaluaciones y actividades desde cero', 'Sin más silencios incómodos frente a una pregunta técnica que te pone en aprietos'];
  return <section className="py-20 bg-slate-900 text-white" data-id="element-18">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-19">
        <div className="text-center mb-12" data-id="element-20">
          <h2 className="text-3xl md:text-4xl font-extrabold mb-4" data-id="element-21">
            🔚 EL CIERRE
          </h2>
          <p className="text-xl text-slate-300" data-id="element-22">
            El próximo lunes podés seguir improvisando... O podés entrar al aula
            con todo listo desde hoy.
          </p>
        </div>

        <div className="bg-slate-950/60 rounded-2xl p-6 md:p-10 border border-slate-800 mb-12 max-w-3xl mx-auto" data-id="element-23">
          <ul className="space-y-6" data-id="element-24">
            {bullets.map((bullet, i) => <li key={i} className="flex items-start gap-4" data-id="element-25">
                <div className="mt-1 bg-slate-800 p-1.5 rounded-full shrink-0 border border-slate-600" data-id="element-26">
                  <X className="w-5 h-5 text-slate-300" data-id="element-27" />
                </div>
                <span className="text-slate-200 text-lg" data-id="element-28">{bullet}</span>
              </li>)}
          </ul>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center bg-gradient-to-br from-blue-900 to-slate-400 rounded-2xl p-8 md:p-12 shadow-2xl border border-slate-500/50" data-id="element-29">
          <p className="md:text-3xl font-black text-white text-[20px] mb-6" data-id="element-30">
            "El MegaPack Técnico en Aeronáutica 360 no te convierte en mejor
            docente. Vos ya sos un buen docente. Lo que hace el MegaPack es
            darte el tiempo y las herramientas para que eso se note en cada
            clase."
          </p>
          <p className="text-slate-200 font-bold text-lg" data-id="element-31">
            El mejor momento para tener este material era al inicio del año. El
            segundo mejor momento es hoy.
          </p>
        </motion.div>
      </div>
    </section>;
}